import { call } from 'redux-saga/effects';
import request from '../../../helpers/request';
import { INDEX_FINANCE_CAMPAIGNS } from '../constants';
import { likeRegex } from '../../../../utils/helperFunctions';
import notify from '../../../helpers/notify';

const formatter = ({
  formValues: {
    query: { name, brand, budget, status, country, fromDate, untilDate },
    ...rest
  },
}) => ({
  formValues: {
    query: {
      'info.name': likeRegex(name),
      'brand.name': brand,
      budget,
      status,
      'campaignContext.dates.startDate': fromDate,
      'campaignContext.dates.endDate': untilDate,
      'brief.country': country,
    },
    ...rest,
  },
});

const indexCampaignsFinanceNotifier = (formValues, loader = false) =>
  notify({
    type: INDEX_FINANCE_CAMPAIGNS,
    formValues,
    loader,
    formatter,
  });

function* indexFinanceCampaignsAction({ formValues }) {
  yield call(request, {
    type: INDEX_FINANCE_CAMPAIGNS,
    method: 'get',
    endpoint: '/campaigns/finance',
    params: formValues,
  });
}

export { indexFinanceCampaignsAction, indexCampaignsFinanceNotifier };
